import { View } from 'react-native';
import { Text } from '@/components/Text';
import { navigate } from '@/navigations/RootNavigation';
import { useChargebeeConsentNavigation } from '@/hooks/useChargebeeConsentNavigation';
import { useDialog } from '@/hooks/useDialog';
import { styles } from './SelectHealthInsurance.styles';
import { PrimaryButton } from '@/components/Button';

export const SelectHealthInsurance = () => {
  const { triggerNavigationOrConsent } = useChargebeeConsentNavigation();
  const { removeDialog } = useDialog();

  return (
    <View style={styles.container}>
      <Text style={styles.infoText}>
        Sind Sie in einer gesetzlichen Krankenkasse versichert? Oder sind Sie
        bei einer privaten Krankenkassen versichert bzw. möchten die App auf
        eigene Rechnung kaufen?
      </Text>
      <View style={styles.buttonRow}>
        <PrimaryButton
          label="Gesetzlich versichert in Deutschland"
          onPress={() => {
            navigate('DigaCodes');
            removeDialog();
          }}
        />
        <PrimaryButton
          label="Privat versichert/Selbstzahler"
          onPress={triggerNavigationOrConsent}
        />
      </View>
    </View>
  );
};
